export class CommonsColors {
  public static readonly TRANSPARENT: string = "#00000000";
  public static readonly WHITE: string = "#FFFFFF";
  public static readonly LAYOUT_BACKGROUND_DEFAULT: string = "#FFFFFF";

}
